export default "__VITE_ASSET__67624b09__"